import ComponentHeader from '../main/ComponentHeader';
import GruntComponents from '../components';
import { userReadOnly } from '../../util/grunt';
import { Box, Modal,ModalBody,ModalContent,ModalHeader,ModalFooter,Button,Spacer, Spinner, IconButton, 
    useToast,Tooltip,Text,Drawer,DrawerBody, DrawerOverlay, Input,
    DrawerContent, DrawerHeader,OrderedList, ListItem } from '@chakra-ui/react';
import {AddIcon,InfoIcon} from '@chakra-ui/icons';
import { getGovScans, addGovScans,getGovScanResult,delGovScanResult,delGovScanResultItem,updGovScanResultItem,updPutnicaSerBr} from '../../util/apiGovScan';
import { getPasmine } from '../../util/apiPasmina';
import { useState,useEffect, useRef } from 'react';
import GovScanTable from './GovScanTable';
import GovScanResult from './GovScanResult';
import GruntPager from '../custom/GruntPager';
import GovScanPutnicaSerBrUpdate from './GovScanPutnicaSerBrUpdate';


const GovScanContainer=({onClosePress,size='xs'})=>{
    //const userCanEdit=lp.uloga.includes("w") || lp.uloga.includes("a")?true:false;
    const [scandata,setScanData]=useState([]);
    const [fileToScan,setFileToScan]=useState({file:null,name:"",type:"",size:0,scaninprogress:false});
    const [err,setErr]=useState("");
    const [prikaz, setPrikaz] = useState({data:[],orderbycol:"datum",orderby:"desc",rowsperpage:25,currpage:1,toggleshow:false});
    const [govscanresult,setGovScanResult]=useState({govscanid:0,govscandata:[],showresults:false,govscanresultitemtodelete:0,err:"",modelskeniranja:"",readonly:false});
    const [pasmine,setPasmine]=useState([])
    const [showinfo,setShowInfo]=useState(false);
    const [govscanidEditPutniceSerBr,setGovscanidEditPutniceSerBr]=useState(0);
    const toast=useToast();
    const inputRef = useRef(null);

    //error
    useEffect(()=>{
        const showErrMessage=()=>{
            if (err!=="") {
                toast({
                    title:"Greška kod dohvata podataka.",
                    status:"error",
                    description:err,
                    isClosable:true,
                    duration:2000,
                    position:"top-right",
                });
                setErr("");
            }
        }
        showErrMessage();
    },[err])

    //upload
    useEffect(()=>{
        const uploadPdf=async()=>{
            try {
                const res=await addGovScans({file:fileToScan.file,name:fileToScan.name,type:fileToScan.type,size:fileToScan.size});
                if (res.status!==200) {
                    throw new Error(res.message);
                }
            } catch (error) {
                setErr(error.message)
            } finally {
                setFileToScan({...fileToScan,file:null,scaninprogress:false});
                setPrikaz({...prikaz,toggleshow:!prikaz.toggleshow});
            }
        }

        
        

        if (fileToScan.scaninprogress) {
            uploadPdf();    
        } 
        
    },[fileToScan.scaninprogress])


    useEffect(()=>{
        const fetchData=async ()=>{
            try {
                const res=await getGovScans(false,false);
                
                if (res.status===200) {
                    setScanData(res.res);
                } else {
                    throw new Error(res.message);
                }
            } catch (error) {
                setErr(error.message)
            }
          }
          fetchData();
    },[prikaz.toggleshow])

    useEffect(()=>{
        const fetchGovScanResult=async()=>{
            try {
                const res=await getGovScanResult({_govscanid:govscanresult.govscanid});
                
                if (res.status===200) {
                    setGovScanResult({...govscanresult,data:res.res,showresults:true});
                } else {
                    throw new Error(res.message);
                }
            } catch (error) {
                setErr(error.message);
            }
        }

        //brisanje
        const delGovScanResItem=async()=>{
            try {
                const res=await delGovScanResultItem(govscanresult.govscanresultitemtodelete);
                
                if (res.status===200) {
                    setGovScanResult({...govscanresult,govscanresultitemtodelete:0});
                } else {
                    throw new Error(res.message);
                }
            } catch (error) {
                setErr(error.message);
            }
        }
        if (govscanresult.govscanid!==0) {
            fetchGovScanResult();
        }
        if (govscanresult.govscanresultitemtodelete!==0) {
            delGovScanResItem();
        }

    },[govscanresult.govscanid,govscanresult.govscanresultitemtodelete])
   
    useEffect(()=>{
        const fetchPasmine=async()=>{
            try {
                const res=await getPasmine();
                
                if (res.status===200) {
                    setPasmine(res.res);
                } else {
                    throw new Error(res.message);
                }
            } catch (error) {
                setErr(error.message);
            }
        }
        fetchPasmine();

    },[])

    const showGovScanResult=()=>{
        if (govscanresult.govscanid!==0 && govscanresult.showresults && govscanresult.data.length!==0) {
            return (
                <Drawer placement='right' size={'xxl'} isOpen={true}>
            <DrawerOverlay/>
            <DrawerContent roundedTopLeft={'md'}>
                <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                    <Box display={'flex'} w={'100%'} h={'100%'}>
                        {"Pregled očitanih putnih listova ("}
                        {`MODEL: ${govscanresult.data.length>0?govscanresult.data[0].model:null})`}
                        <Text fontSize={'1rem'} color={'black'}>
                            
                        </Text>
                        
                        
                    </Box>
                    
                </DrawerHeader>
                <DrawerBody>
                        <GovScanResult readonly={govscanresult.readonly} data={govscanresult.data} size='xs' onClose={closeGovScanResult} onDelete={onDeleteScanItem} onUpdateItem={onUpdateScanItem} pasmine={pasmine} errmsg={govscanresult.err} drzavamodelskeniranja={govscanresult.modelskeniranja}/>
                </DrawerBody>
            </DrawerContent>
            </Drawer>
            )
        }
    }

    const showEditPutniceSerBr=()=>{
        if (govscanidEditPutniceSerBr!==0) {
            return (
                <Drawer placement='right' size={'md'} isOpen={true}>
            <DrawerOverlay/>
            <DrawerContent roundedTopLeft={'md'}>
                <DrawerHeader pt='5px' roundedTopLeft={'md'} h={'40px'} color={'white'}  bg={'grunt2.700'}>
                    <Box display={'flex'} w={'100%'} h={'100%'}>
                        {"Ažuriranje putnih listova"}
                        
                        
                        
                    </Box>
                    
                </DrawerHeader>
                <DrawerBody>
                        <GovScanPutnicaSerBrUpdate govscanid={govscanidEditPutniceSerBr} onUpdate={onUpdatePutnicaSerBr} onClose={()=>setGovscanidEditPutniceSerBr(0)} />
                </DrawerBody>
            </DrawerContent>
            </Drawer>
            )
        }
    }
    const onUpdatePutnicaSerBr=async()=>{
        try {
            const res=await updPutnicaSerBr({_govscanid:govscanidEditPutniceSerBr})
            if (res.status===200) {
                
                setGovscanidEditPutniceSerBr(0);
            } else {
                setErr(res.message);
            }
            
        } catch (error) {
            setErr(error.message);
        }
        
    }
//{_govscanresultid=0,_zivbradjusted="",_mzivbradjusted="",_spoladjusted="",_pasminasifraadjusted="",_datrodadjusted}
    const onUpdateScanItem=async (id,zivbradjusted,mzivbradjusted,spoladjusted,pasmsifraadjusted,datrodadjusted,pasminaadjusted,putnica_serbr_adjusted)=>{
        setGovScanResult({...govscanresult,err:""});
        try {
            const res=await updGovScanResultItem({_govscanresultid:id,_zivbradjusted:zivbradjusted,_mzivbradjusted:mzivbradjusted,_spoladjusted:spoladjusted,_pasminasifraadjusted:pasmsifraadjusted,_datrodadjusted:datrodadjusted,_putnica_serbr_adjusted:putnica_serbr_adjusted});
            
            if (res.status===200) {
                setGovScanResult({...govscanresult,err:""});
                //ažuriraj podatke lokalno
                const _ar=govscanresult.data;
                let pos=_ar.map((e)=>{
                    return e.id;
                   }).indexOf(id);
                   if (pos>-1) {
                        _ar[pos].zivbr_adjusted=zivbradjusted;
                        _ar[pos].zivbr_isvalid=true;
                        _ar[pos].mzivbr_adjusted=mzivbradjusted;
                        _ar[pos].mzivbr_isvalid=true;
                        _ar[pos].spol_adjusted=spoladjusted;
                        _ar[pos].spol_isvalid=true;
                        _ar[pos].pasminasifra_adjusted=pasmsifraadjusted;
                        _ar[pos].pasmina_adjusted=pasminaadjusted;
                        _ar[pos].pasmina_isvalid=true;
                        _ar[pos].datrod_adjusted=datrodadjusted;
                        _ar[pos].datrod_isvalid=true;
                        _ar[pos].putnica_serbr_adjusted=putnica_serbr_adjusted;
                        _ar[pos].putnica_serbr_isvalid=true;
                        //
                        _ar[pos].podaci_validirani=true;
                        //ažuriranje pasmina svih goveda
                        
                        for (let i = 0; i < _ar.length; i++) {
                            if (_ar[i].pasmina.toLowerCase()===_ar[pos].pasmina.toLowerCase()) {
                                _ar[i].pasmina_adjusted=pasminaadjusted;
                            }
                            
                        }
                        setGovScanResult({...govscanresult,data:_ar});
                   }
            } else {
                setGovScanResult({...govscanresult,err:res.message});
            }
        } catch (error) {
            setGovScanResult({...govscanresult,err:error.message});
        }
    }

    const onDeleteScanItem=(id)=>{
        setGovScanResult({...govscanresult,err:""});
        //ažuriraj podatke lokalno
       
       const _ar = [...govscanresult.data];
       let pos=_ar.map((e)=>{
        return e.id;
       }).indexOf(id);
       if (pos>-1) {
            _ar.splice(pos,1);
            setGovScanResult({...govscanresult,data:_ar});
       }
       setGovScanResult({...govscanresult,govscanresultitemtodelete:id});
    }

    const closeGovScanResult=()=>{
        setPrikaz({...prikaz,toggleshow:!prikaz.toggleshow});
        setGovScanResult({...govscanresult,govscanid:0,data:[],showresults:false,errmsg:""});
    }
      
    const showInfo=()=>{
        
            return (
                <>
                    <Modal isOpen={showinfo} size={'lg'}>
        
                        <ModalContent>
                        <ModalHeader color={'grunt2'}>
                            Podržane vrste dokumenata za skeniranje
                        </ModalHeader>
                        
                        <ModalBody>
                            <Box>
                                Podržani putni listovi sljedećih država:
                                <Box pl={'1rem'} pt={'1rem'}>
                                    <OrderedList>
                                        <ListItem>Austrije</ListItem>
                                        <ListItem>Češke</ListItem>
                                        <ListItem>Estonije</ListItem>
                                        <ListItem>Francuske</ListItem>
                                        <ListItem>Hrvatske</ListItem>
                                        <ListItem>Irske</ListItem>
                                        <ListItem>Italije</ListItem>
                                        <ListItem>Latvije</ListItem>
                                        <ListItem>Mađarske</ListItem>
                                        <ListItem>Nizozemske</ListItem>
                                        <ListItem>Rumunjske</ListItem>
                                        <ListItem>Slovačke</ListItem>        
                                    </OrderedList>
                                </Box>
                            </Box>
                        </ModalBody>

                        <ModalFooter>
                            <Button colorScheme='grunt2' variant={'solid'} mr={3} size={size} onClick={()=>setShowInfo(false)}>
                            Povratak
                            </Button>
                            
                        </ModalFooter>
                        </ModalContent>
                    </Modal>
                </>
            )
        
    }

    
    const dataToShow=()=>{
        const _res=scandata.slice((prikaz.currpage-1)*prikaz.rowsperpage,(prikaz.currpage)*prikaz.rowsperpage);
        return _res;
    }
    const pocetniRbr=()=>{
        return ((prikaz.currpage-1)*prikaz.rowsperpage)+1
    }
    const handleSelectFileClick = () => {
        // 👇️ open file input box on click of another element
        inputRef.current.click();
      };
    const handleFileChange = event => {
        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj) {
          return;
        }
        const _rgx=/(.*đ.*)|(.*č.*)|(.*ć.*)|(.*š.*)|(.*ž.*)/ig;
        const _ar=fileObj.name.match(_rgx);
        if (_ar?.length>0) {
            setErr("Neispravan naziv datoteke (preimenujete datoteku na način da zamijenite dijakritičke znakove)!")
        } else {
            setFileToScan({...fileToScan,file:fileObj,name:fileObj.name,type:fileObj.type,size:fileObj.size,scaninprogress:true})
        }
    
        
        
        
      };

      
    const btnNew=()=>{
            
            if (fileToScan.scaninprogress) {
                return (<><Spinner color='grunt.400'/></>)
            } else {
                return (
                    //<Button isDisabled={_isDisabled} mb={'0.5rem'} rightIcon={<SmallAddIcon/>} colorScheme={'grunt2'} variant={'outline'} size={size}>Kriraj</Button>
                    <>
                    <Input focusBorderColor='grunt2.400'
                    style={{display: 'none'}}
                    ref={inputRef}
                    type="file" accept='.pdf'
                    onChange={handleFileChange}
          />
                    <Tooltip label='Započni novo skeniranje' placement='left-start'>
                        <IconButton onClick={handleSelectFileClick} variant={'outline'} colorScheme={'grunt2'} title='Započni skeniranje' aria-label='Novo skeniranje' icon={<AddIcon/>} size={size}/>
                    </Tooltip>
                    </>
                    )
            }
            
        
    }
    
    const ShowGruntPager=()=>{
        if (scandata.length>0) {
            return (
                <GruntPager buttonsize={'xs'} currpage={prikaz.currpage} rowcount={scandata.length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
                );    
        }
        
    }
const getInfoButton=()=>{
    return (
        <Tooltip label='Podržani dokumenti sljedećih država:' placement='left-start'>
            <IconButton onClick={()=>setShowInfo(true)} variant={'link'} colorScheme={'grunt2'} aria-label='Novo skeniranje' icon={<InfoIcon/>} size={'size'}/>
        </Tooltip>
    )
}
const getHeader=()=>{
    return (
        <>
            <ComponentHeader onClosePress={onClosePress} component={GruntComponents.SkeniranjePutnihListova}/>
            <Box  display={'flex'} alignItems={'center'} mb={'0.5rem'} ml={'1rem'} mr={'1rem'}>
                
                {/* <Stack direction={'row'} spacing={'1rem'} mr={'1rem'}> */}
                    {getInfoButton()}
                    <Spacer/>
                    {userReadOnly()?null:btnNew()}    
                {/* </Stack> */}
            </Box>
            
        </>
    )
}
const showBrZapis=()=>{
    return (
      <Text fontSize={'xs'}>Prikazano zapisa: {scandata.length}</Text>
    )
  }
const getFooter=()=>{
    return (
        
        <Box flexDir={'row'} display={'flex'} w="100%">
            
            <Box w="10%">
                {showBrZapis()}
            </Box>
            <Box w="80%" textAlign={'center'}>
                {ShowGruntPager()}
            </Box>
            <Box w="10%">
                
            </Box>
        </Box>
        
    )
}

const startEditItem=(_govscanid,_model,_readonly)=>{
    setGovScanResult({...govscanresult,govscanid:_govscanid,err:"",modelskeniranja:_model,readonly:_readonly});
}

const startEditPutniceSerBr=(_govscanid)=>{
    setGovscanidEditPutniceSerBr(_govscanid);
}

const deleteGovScan=async (govscanid)=>{
    
        try {
            const res=await delGovScanResult({_govscanid:govscanid});
            
            if (res.status===200) {
                setPrikaz({...prikaz,toggleshow:!prikaz.toggleshow});
            } else {
                setErr(res.message);
            }
        } catch (error) {
            setErr(error.message);
        }
}

const showData=()=>{
    return (
        <Box display={'flex'} flexDir={'column'} flex={1}>
            <GovScanTable readonly={userReadOnly()} data={dataToShow()} pocetnirbr={pocetniRbr()} onEditItem={startEditItem} onDeleteItem={deleteGovScan} mode={'all'} onStartUpdatePutniceSerBr={startEditPutniceSerBr}/>
        </Box>
    )
}

return (
    <Box display={'flex'} flexDir={'column'} h={'100%'} borderColor={'silver'} borderBottomRightRadius={'md'} borderWidth={'0.5px'} key='drzave_component' pl={'0.5rem'} pr={'0.5rem'} pb={'0.2rem'}>
            
        {getHeader()}
        {showData()}
        {showGovScanResult()}
        {showEditPutniceSerBr()}
        {showInfo()}
        {getFooter()}
        
    </Box>
)
}

export default GovScanContainer;